"use client";
import r from "styled-components";
const t = r.div`
  display: flex;
  flex-wrap: wrap;
  & > * {
    margin-right: 0.75rem;
    margin-bottom: 0.5rem;
  }
  & > *:last-child {
    margin-right: 0;
  }
`;
export {
  t as default
};
//# sourceMappingURL=index.es54.js.map
